<div class="container-fluid">
    <div class="row">
        <div class="col-11 d-flex   personal-details">
            <span class=" personal">
                <img src="assets/settingIcon/user.png">
            </span>

            <div class="personal"> 
                <h5> <b>Personal details </b></h5>
                <p style="color: #6D6D6D;"> Update Your Personal Information</p>
                <a routerLink="/personaldetails" > <b style="color: #286676;" >Manage Personal details  </b> </a> 
            </div>
            
            
        </div>
    </div>
    <div class="row">
        <div class="col-11 d-flex   personal-details">
            <span class=" personal">
                <img src="assets/settingIcon/notification.png">
            </span>

            <div class="personal"> 
                <h5> <b>Notifications </b></h5>
                <p style="color: #6D6D6D;"> Decide what you want to be notified about and unsubcribe from what you don't </p>
               <a routerLink="/personaldetails" > <b style="color: #286676;" >Manage Personal details  </b></a> 
            </div>
            
            
        </div>
    </div>
    <div class="row">
        <div class="col-11 d-flex   personal-details">
            <span class=" personal">
                <img src="assets/settingIcon/preference.png">
            </span>

            <div class="personal"> 
                <h5> <b>Preferences </b></h5>
                <p style="color: #6D6D6D;"> Change Your Language</p>
                <b style="color: #286676;" >Manage Personal details  </b>
            </div>
            
            
        </div>
    </div>
    <div class="row">
        <div class="col-11 d-flex   personal-details">
            <span class=" personal">
                <img src="assets/settingIcon/security.png">
            </span>

            <div class="personal"> 
                <h5> <b>Security </b></h5>
                <p style="color: #6D6D6D;"> Change Your Language</p>
                <b style="color: #286676;" >Manage Personal details  </b>
            </div>
            
            
        </div>
    </div>
</div>
